import React from 'react';
import {Route, Switch, useRouteMatch} from "react-router-dom";

// Substitution Pages
import NewSubstitution from "./New";
import MainPage from "./MainPage";

const Substitutions = () => {
   const match = useRouteMatch();

   return <Switch>
      <Route exact path={`${match.path}/new`} component={NewSubstitution}/>

      <Route exact path={`${match.path}`} component={MainPage}/>
   </Switch>
}

export default Substitutions;